







































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { FuelLabel } from '@/common/fuels';
import { ShortDecimalInput } from '@/common/number';
import { DailyReport } from '@/models/dailyReport.model';
import { DailyReportTank } from '@/models/dailyReportTank.model';
import { Fuel } from '@/models/fuel.model';
import EditPageDailyReportTankInput from '@/pages/index/pages/edit/components/EditPageDailyReportTankInput.vue';
import { LocationStore } from '@/store/location';

@Component({
  components: {
    EditPageDailyReportTankInput,
    FuelLabel,
    ShortDecimalInput,
  },
})
export default class EditPageDailyReportInput extends Vue {
  @Prop() disabled!: boolean;
  @Prop() fuel!: Fuel;
  @Prop() isActive!: boolean;
  @Prop() readonly!: boolean;
  @Prop() report!: DailyReport;

  @LocationStore.Bind.Getter heightUoms!: LocationStore.Getter<'heightUoms'>;
  @LocationStore.Bind.Getter volumeUoms!: LocationStore.Getter<'volumeUoms'>;

  get useActiveStyling() {
    const $vuetify = this['$vuetify'] as any;  //as VuetifyObject;
    return this.isActive && $vuetify.breakpoint.smAndUp;
  }

  get tanksById() {
    return this.fuel.tanks.reduce((result, tank) => {
      result[tank.tankId] = tank;
      return result;
    }, {});
  }

  @Emit('input')
  emitChange(changes: Partial <DailyReport>) {
    return { ...this.report, ...changes };
  }

  @Emit('input')
  emitChangeWithTank(tankIndex: number, tank: DailyReportTank) {
    const tanks = [
      ...this.report.tanks.slice(0, tankIndex),
      tank,
      ...this.report.tanks.slice(tankIndex + 1),
    ];

    return { ...this.report, tanks };
  }

  @Emit('focus')
  emitFocused() { }

  setFocus(refName: string) {
    const ref = this.$refs[refName] as ShortDecimalInput | EditPageDailyReportTankInput[];
    const input = Array.isArray(ref) ? ref[0] : ref;

    if (input) {
      input.focus();
    }
    else {
      this.$emit('submit');
    }
  }

  focus() {
    const ref = this.$refs.input1 as ShortDecimalInput;
    ref.focus();
  }

}
